import { render, staticRenderFns } from "./UserStatusKey.vue?vue&type=template&id=25f775ca&"
import script from "./UserStatusKey.vue?vue&type=script&lang=js&"
export * from "./UserStatusKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f775ca')) {
      api.createRecord('25f775ca', component.options)
    } else {
      api.reload('25f775ca', component.options)
    }
    module.hot.accept("./UserStatusKey.vue?vue&type=template&id=25f775ca&", function () {
      api.rerender('25f775ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Admin/UserStatusKey.vue"
export default component.exports